export const environment = {
  production: false,
  cmsApiUrl: "https://staging.cms.kasha.co/api",
  googleClientId: "1082734459375-dtnesf1quv78cctdr79cja6k9uve02pb.apps.googleusercontent.com",
  checkTokenInterval: 60000,
  serviceUrls: {
    rwandaEnrollment: "staging.pds-enrollment.kasha.rw",
    rwandaDelivery: "staging.pds-delivery-form.kasha.rw",
    rwandaDashboard: "staging.pds-delivery-dashboard.kasha.rw",
    nigeriaDashboard: "staging.pds-delivery-dashboard.kasha.rw"
  }
};
